export default __webpack_public_path__ + "login-background.2b83a4a2408841e89664cd2411ab7473.svg";